import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { mediaUrl } from "../config";

const Player = ({ video, autoPlay = true, className = "" }) => {
  const ref = useRef(null);
  const [preparing, setPreparing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || !video) return;
    setPreparing(false);
    const url = video.webVideoUrl || video.videoUrl;
    if (!url) return;
    const src = mediaUrl(url);
    const isHls = video.streamType === "hls" || src.includes(".m3u8");
    let hls;
    if (isHls) {
      if (el.canPlayType("application/vnd.apple.mpegurl")) {
        el.src = src;
      } else if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(el);
      } else {
        setPreparing(true);
      }
    } else {
      el.src = src;
    }
    return () => {
      if (hls) hls.destroy();
    };
  }, [video]);

  if (preparing) {
    return (
      <div className={`relative flex items-center justify-center overflow-hidden bg-surface ${className}`} data-testid="player-preparing">
        {mediaUrl(video?.thumbnail) && (
          <img src={mediaUrl(video.thumbnail)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        )}
        <p className="relative font-heading text-sm font-semibold text-white">Getting ready…</p>
      </div>
    );
  }

  return (
    <video
      ref={ref}
      controls
      playsInline
      autoPlay={autoPlay}
      poster={mediaUrl(video?.thumbnail) || undefined}
      className={`bg-black ${className}`}
      data-testid="video-player"
    />
  );
};

export default Player;
